//Directus endpoint domains

export const DOMAIN = process.env.REACT_APP_DIRECTUS_URL;
